module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.1@core-js/library/modules/_fails.js
// module id = 42
// module chunks = 0